import { DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';
import banner from 'assets/dashboard/banner.png';
import app from 'assets/dashboard/app.png';
import lobbyBanner from 'assets/dashboard/lobbyBanner.png';
import notice from 'assets/dashboard/notice.png';
import coupon from 'assets/dashboard/coupon.png';
import partnerCoupon from 'assets/dashboard/partnerCoupon.png';
import questionBank from 'assets/dashboard/questionBankIcon.png';
import athenaDashboard from 'assets/dashboard/awsAthena.png';
import tournament from 'assets/dashboard/tournament.png';
import apk from 'assets/dashboard/apk.png';
import abTest from 'assets/dashboard/abTest.png';
import quiz from 'assets/dashboard/quiz.png';
// import example from 'assets/dashboard/example.png';
import wallet from 'assets/dashboard/wallet.png';
import social from 'assets/dashboard/social.png';
import staticSegment from 'assets/dashboard/staticSegments.png';
import scheduledDowntime from 'assets/dashboard/scheduledDowntime.png';
import userSegment from 'assets/dashboard/userSegment.png';
import downtimeRefund from 'assets/dashboard/DowntimeRefund.png';
import referral from 'assets/dashboard/referral.png';
import cashback from 'assets/dashboard/cashback.png';
import utilities from 'assets/dashboard/utilities.png';
import happyHour from 'assets/dashboard/happy_hour.png';
import magicBox from 'assets/dashboard/magicBox.png';
import outbound from 'assets/dashboard/outbound.png';
import delink from 'assets/dashboard/delink.png';
import internalUser from 'assets/dashboard/internalUser.png';
import ruleEngine from 'assets/dashboard/ruleEngine.png';
import superSix from 'assets/dashboard/superSix.png';
import themesZipValidationIcon from 'assets/dashboard/jipfile.png';
import lottery from 'assets/dashboard/lottery.png';
import bonusMoneyLambda from 'assets/dashboard/bonusMoneyLambda.png';
import aiCompanion from 'assets/dashboard/aiCompanion.svg';
import config from 'config';
import BannerDashboard from './banner';
import CouponDashboard from './coupon';
import PartnerCouponsDashboard from './partnerCoupons';
import TournamentDasboard from './tournamentV2';
import ApkUpdateDashboard from './apkUpdateInfo';
import ABTestDashboard from './abTest';
// import ExampleDashboard from './example';
import WalletDashboard from './wallet';
import HomePageLayoutDashboard from './homePageLayout';
import MttSchemaDashboard from './mttSchema';
import SocialInfo from './social';
import StaticSegmentsDashboard from './staticSegments';
import ScheduledDowntime from './scheduledDowntime';
import UserSegmentsDashboard from './userSegment';
import DowntimeRefundDashboard from './downtimeRefund';
import ReferralDashboard from './referral';
import QuestionBank from './questionBank';
import NoticeDashboard from './notices';
import LobbyBannerDashboard from './lobbyBanner';
import cashbackUtilDashboard from './cashbackUtil';
import PredictAndWinDashboard from './pnwContest';
import utilitiesDashboard from './utilities';
import HappyHourDashboard from './happyHours';
import ZupeeKheloJeetoDashboard from './zupeeKheloJeetoQnA';
import MagicBoxDashboard from './magicBox';
import HomepageViewDashboard from './homePageView';
import OutboundDashboard from './outbound';
import DelinkDashboard from './delink';
import Finance from './finance';
import { CTD_RESOURCES } from './finance/ctd/ctdHelper';
import RuleEngineCard from './rule-engine';
import SuperSix from './superSix';
import ThemesZipValidationDashboard from './themesZipValidation';
import LotteryDashboardHome from './lottery';
import BonusMoneyLambdaDashboard from './bonusMoneyLambda';
import InternalUserDashboard from './internaluser';
import TournamentRevamp from './TournamentRevamp';
import AthenaDashboard from './athenaDashboard';
import AdsDashboard from './adsDashboard';
import ChatDashboard from './chatDashboard';
import AiCompanionDashboard from './aiCompanionDashboard';
import GameplayGuardrailReviewDashboard from './gameplayGuardrailReview';
import ConfigImpactDashboard from './configImpact';
import TalkzyDataDashboard from './talkzyData';
import MandateRefundDashboard from './mandateRefund';

export const URL = {
	[DASHBOARD_RESOURCES.banner]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.banner}`,
	[DASHBOARD_RESOURCES.lobbyBanner]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.lobbyBanner}`,
	[DASHBOARD_RESOURCES.homepageView]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.homepageView}`,
	[DASHBOARD_RESOURCES.coupon]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.coupon}`,
	[DASHBOARD_RESOURCES.tournament]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.tournament}`,
	[DASHBOARD_RESOURCES.tournamentV2]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.tournamentV2}`,
	[DASHBOARD_RESOURCES.partnerCoupon]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.partnerCoupon}`,
	[DASHBOARD_RESOURCES.apkUpdateInfo]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.apkUpdateInfo}`,
	[DASHBOARD_RESOURCES.abTest]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.abTest}`,
	// [DASHBOARD_RESOURCES.example]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.example}`
	[DASHBOARD_RESOURCES.wallet]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.wallet}`,
	[DASHBOARD_RESOURCES.homePageLayout]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.homePageLayout}`,
	[DASHBOARD_RESOURCES.mttSchema]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.mttSchema}`,
	[DASHBOARD_RESOURCES.staticSegments]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.staticSegments}`,
	[DASHBOARD_RESOURCES.social]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.social}`,
	[DASHBOARD_RESOURCES.scheduledDowntime]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.scheduledDowntime}`,
	[DASHBOARD_RESOURCES.userSegment]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.userSegment}`,
	[DASHBOARD_RESOURCES.referral]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.referral}`,
	[DASHBOARD_RESOURCES.questionBank]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.questionBank}`,
	[DASHBOARD_RESOURCES.notices]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.notices}`,
	[CTD_RESOURCES.ctdOffers]: `/${PAGE_NAMES.dashboard}/${CTD_RESOURCES.ctdOffers}`,
	[CTD_RESOURCES.ctdConfigs]: `/${PAGE_NAMES.dashboard}/${CTD_RESOURCES.ctdConfigs}`,
	[DASHBOARD_RESOURCES.cashbackUtil]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.cashbackUtil}`,
	[DASHBOARD_RESOURCES.predictAndWinV2]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.predictAndWinV2}`,
	[DASHBOARD_RESOURCES.utilities]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.utilities}`,
	[DASHBOARD_RESOURCES.happyHour]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.happyHour}`,
	[DASHBOARD_RESOURCES.zupeeKheloJeeto]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.zupeeKheloJeeto}`,
	[DASHBOARD_RESOURCES.downtimeRefund]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.downtimeRefund}`,
	[DASHBOARD_RESOURCES.outbound]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.outbound}`,
	[DASHBOARD_RESOURCES.magicBox]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.magicBox}`,
	[DASHBOARD_RESOURCES.delink]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.delink}`,
	[CTD_RESOURCES.priorityConfigurator]: `/${PAGE_NAMES.dashboard}/${CTD_RESOURCES.priorityConfigurator}`,
	[DASHBOARD_RESOURCES.finance]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}`,
	[DASHBOARD_RESOURCES.ruleEngine]: config.URL_ENV_MAP[DASHBOARD_RESOURCES.ruleEngine],
	[DASHBOARD_RESOURCES.tournamentV2]: config.URL_ENV_MAP[DASHBOARD_RESOURCES.tournamentV2],
	[DASHBOARD_RESOURCES.superSix]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.superSix}`,
	[DASHBOARD_RESOURCES.lottery]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.lottery}`,
	[DASHBOARD_RESOURCES.athenaDashboard]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.athenaDashboard}`,
	[DASHBOARD_RESOURCES.bonusMoneyLambda]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.bonusMoneyLambda}`,
	[DASHBOARD_RESOURCES.themesZipValidation]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.themesZipValidation}`,
	[DASHBOARD_RESOURCES.internalUser]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.internalUser}`,
	[DASHBOARD_RESOURCES.adsDashboard]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.adsDashboard}`,
	[DASHBOARD_RESOURCES.chatDashboard]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.chatDashboard}`,
	[DASHBOARD_RESOURCES.aiCompanionDashboard]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.aiCompanionDashboard}`,
	[DASHBOARD_RESOURCES.gameplayGuardrailReview]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.gameplayGuardrailReview}`,
	[DASHBOARD_RESOURCES.configImpact]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.configImpact}`,
	[DASHBOARD_RESOURCES.talkzyData]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.talkzyData}`,
	[DASHBOARD_RESOURCES.mandateRefund]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.mandateRefund}`
};

export const LABEL = {
	[DASHBOARD_RESOURCES.banner]: 'Home/Wallet Banners',
	[DASHBOARD_RESOURCES.lobbyBanner]: 'Lobby Banners',
	[DASHBOARD_RESOURCES.homepageView]: 'Home Page View',
	[DASHBOARD_RESOURCES.coupon]: 'Coupons',
	[DASHBOARD_RESOURCES.tournament]: 'Tournaments',
	[DASHBOARD_RESOURCES.partnerCoupon]: 'Partner Coupons',
	[DASHBOARD_RESOURCES.apkUpdateInfo]: 'Apk Updates',
	[DASHBOARD_RESOURCES.homePageLayout]: 'HomePage Layout',
	[DASHBOARD_RESOURCES.abTest]: 'AB Test',
	// [DASHBOARD_RESOURCES.example]: 'Example'
	[DASHBOARD_RESOURCES.wallet]: 'Wallet',
	[DASHBOARD_RESOURCES.mttSchema]: 'Mtt Schema',
	[DASHBOARD_RESOURCES.staticSegments]: 'Static Segments',
	[DASHBOARD_RESOURCES.social]: 'Social',
	[DASHBOARD_RESOURCES.scheduledDowntime]: 'Scheduled Downtime',
	[DASHBOARD_RESOURCES.userSegment]: 'User Segment',
	[DASHBOARD_RESOURCES.downtimeRefund]: 'Downtime Refund',
	[DASHBOARD_RESOURCES.outbound]: 'Outbound',
	[DASHBOARD_RESOURCES.referral]: 'Referral',
	[DASHBOARD_RESOURCES.questionBank]: 'Question Bank',
	[DASHBOARD_RESOURCES.notices]: 'Notices',
	[CTD_RESOURCES.ctdOffers]: 'CTD Offers',
	[CTD_RESOURCES.ctdConfigs]: 'CTD segment configurations',
	[DASHBOARD_RESOURCES.cashbackUtil]: 'Cashback Utilization',
	[DASHBOARD_RESOURCES.predictAndWinV2]: 'Predict & Win Contest',
	[DASHBOARD_RESOURCES.utilities]: 'Utilities',
	[DASHBOARD_RESOURCES.happyHour]: 'Happy Hours',
	[DASHBOARD_RESOURCES.zupeeKheloJeeto]: 'Zupee Khelo Jeeto QnA',
	[DASHBOARD_RESOURCES.magicBox]: 'Magic Box',
	[DASHBOARD_RESOURCES.delink]: 'Delink User',
	[CTD_RESOURCES.priorityConfigurator]: 'Priority Configurator',
	[DASHBOARD_RESOURCES.finance]: 'Finance',
	[DASHBOARD_RESOURCES.ruleEngine]: 'Rule Engine',
	[DASHBOARD_RESOURCES.superSix]: 'Super Six',
	[DASHBOARD_RESOURCES.lottery]: 'Lottery',
	[DASHBOARD_RESOURCES.bonusMoneyLambda]: 'Bonus Money Lambda',
	[DASHBOARD_RESOURCES.tournamentV2]: 'Tournament Vortex',
	[DASHBOARD_RESOURCES.themesZipValidation]: 'Themes Zip Validation',
	[DASHBOARD_RESOURCES.internalUser]: 'Internal User',
	[DASHBOARD_RESOURCES.athenaDashboard]: 'Athena Dashboard',
	[DASHBOARD_RESOURCES.adsDashboard]: 'Ads Dashboard',
	[DASHBOARD_RESOURCES.chatDashboard]: 'Chat Dashboard',
	[DASHBOARD_RESOURCES.aiCompanionDashboard]: 'AI Companion Dashboard',
	[DASHBOARD_RESOURCES.gameplayGuardrailReview]: 'Gameplay Guardrail Review System',
	[DASHBOARD_RESOURCES.configImpact]: 'Config Impact Analysis',
	[DASHBOARD_RESOURCES.talkzyData]: 'Talkzy Data',
	[DASHBOARD_RESOURCES.mandateRefund]: 'Mandate Refund'
};

export const COMPONENT = {
	[DASHBOARD_RESOURCES.banner]: BannerDashboard,
	[DASHBOARD_RESOURCES.lobbyBanner]: LobbyBannerDashboard,
	[DASHBOARD_RESOURCES.homepageView]: HomepageViewDashboard,
	[DASHBOARD_RESOURCES.coupon]: CouponDashboard,
	[DASHBOARD_RESOURCES.tournament]: TournamentDasboard,
	[DASHBOARD_RESOURCES.tournamentV2]: TournamentRevamp,
	[DASHBOARD_RESOURCES.partnerCoupon]: PartnerCouponsDashboard,
	[DASHBOARD_RESOURCES.apkUpdateInfo]: ApkUpdateDashboard,
	[DASHBOARD_RESOURCES.abTest]: ABTestDashboard,
	// [DASHBOARD_RESOURCES.example]: ExampleDashboard
	[DASHBOARD_RESOURCES.wallet]: WalletDashboard,
	[DASHBOARD_RESOURCES.homePageLayout]: HomePageLayoutDashboard,
	[DASHBOARD_RESOURCES.mttSchema]: MttSchemaDashboard,
	[DASHBOARD_RESOURCES.staticSegments]: StaticSegmentsDashboard,
	[DASHBOARD_RESOURCES.social]: SocialInfo,
	[DASHBOARD_RESOURCES.scheduledDowntime]: ScheduledDowntime,
	[DASHBOARD_RESOURCES.userSegment]: UserSegmentsDashboard,
	[DASHBOARD_RESOURCES.downtimeRefund]: DowntimeRefundDashboard,
	[DASHBOARD_RESOURCES.outbound]: OutboundDashboard,
	[DASHBOARD_RESOURCES.referral]: ReferralDashboard,
	[DASHBOARD_RESOURCES.questionBank]: QuestionBank,
	[DASHBOARD_RESOURCES.notices]: NoticeDashboard,
	[DASHBOARD_RESOURCES.cashbackUtil]: cashbackUtilDashboard,
	[DASHBOARD_RESOURCES.predictAndWinV2]: PredictAndWinDashboard,
	[DASHBOARD_RESOURCES.utilities]: utilitiesDashboard,
	[DASHBOARD_RESOURCES.happyHour]: HappyHourDashboard,
	[DASHBOARD_RESOURCES.zupeeKheloJeeto]: ZupeeKheloJeetoDashboard,
	[DASHBOARD_RESOURCES.magicBox]: MagicBoxDashboard,
	[DASHBOARD_RESOURCES.delink]: DelinkDashboard,
	[DASHBOARD_RESOURCES.finance]: Finance,
	[DASHBOARD_RESOURCES.ruleEngine]: RuleEngineCard,
	[DASHBOARD_RESOURCES.superSix]: SuperSix,
	[DASHBOARD_RESOURCES.lottery]: LotteryDashboardHome,
	[DASHBOARD_RESOURCES.athenaDashboard]: AthenaDashboard,
	[DASHBOARD_RESOURCES.bonusMoneyLambda]: BonusMoneyLambdaDashboard,
	[DASHBOARD_RESOURCES.themesZipValidation]: ThemesZipValidationDashboard,
	[DASHBOARD_RESOURCES.internalUser]: InternalUserDashboard,
	[DASHBOARD_RESOURCES.adsDashboard]: AdsDashboard,
	[DASHBOARD_RESOURCES.chatDashboard]: ChatDashboard,
	[DASHBOARD_RESOURCES.aiCompanionDashboard]: AiCompanionDashboard,
	[DASHBOARD_RESOURCES.gameplayGuardrailReview]: GameplayGuardrailReviewDashboard,
	[DASHBOARD_RESOURCES.configImpact]: ConfigImpactDashboard,
	[DASHBOARD_RESOURCES.talkzyData]: TalkzyDataDashboard,
	[DASHBOARD_RESOURCES.mandateRefund]: MandateRefundDashboard
};

export const IMAGE_SOURCE = {
	[DASHBOARD_RESOURCES.banner]: banner,
	[DASHBOARD_RESOURCES.lobbyBanner]: lobbyBanner,
	[DASHBOARD_RESOURCES.homepageView]: app,
	[DASHBOARD_RESOURCES.homePageLayout]: banner,
	[DASHBOARD_RESOURCES.coupon]: coupon,
	[DASHBOARD_RESOURCES.tournament]: tournament,
	[DASHBOARD_RESOURCES.tournamentV2]: tournament,
	[DASHBOARD_RESOURCES.partnerCoupon]: partnerCoupon,
	[DASHBOARD_RESOURCES.apkUpdateInfo]: apk,
	[DASHBOARD_RESOURCES.abTest]: abTest,
	// [DASHBOARD_RESOURCES.example]: example
	[DASHBOARD_RESOURCES.wallet]: wallet,
	[DASHBOARD_RESOURCES.mttSchema]: partnerCoupon,
	[DASHBOARD_RESOURCES.staticSegments]: staticSegment,
	[DASHBOARD_RESOURCES.social]: social,
	[DASHBOARD_RESOURCES.scheduledDowntime]: scheduledDowntime,
	[DASHBOARD_RESOURCES.userSegment]: userSegment,
	[DASHBOARD_RESOURCES.downtimeRefund]: downtimeRefund,
	[DASHBOARD_RESOURCES.referral]: referral,
	[DASHBOARD_RESOURCES.questionBank]: questionBank,
	[DASHBOARD_RESOURCES.notices]: notice,
	[CTD_RESOURCES.ctdOffers]: coupon,
	[CTD_RESOURCES.ctdConfigs]: coupon,
	[DASHBOARD_RESOURCES.cashbackUtil]: cashback,
	[DASHBOARD_RESOURCES.predictAndWinV2]: quiz,
	[DASHBOARD_RESOURCES.utilities]: utilities,
	[DASHBOARD_RESOURCES.happyHour]: happyHour,
	[DASHBOARD_RESOURCES.zupeeKheloJeeto]: questionBank,
	[DASHBOARD_RESOURCES.magicBox]: magicBox,
	[DASHBOARD_RESOURCES.outbound]: outbound,
	[DASHBOARD_RESOURCES.delink]: delink,
	[CTD_RESOURCES.priorityConfigurator]: coupon,
	[DASHBOARD_RESOURCES.finance]: coupon,
	[DASHBOARD_RESOURCES.ruleEngine]: ruleEngine,
	[DASHBOARD_RESOURCES.superSix]: superSix,
	[DASHBOARD_RESOURCES.themesZipValidation]: themesZipValidationIcon,
	[DASHBOARD_RESOURCES.lottery]: lottery,
	[DASHBOARD_RESOURCES.bonusMoneyLambda]: bonusMoneyLambda,
	[DASHBOARD_RESOURCES.internalUser]: internalUser,
	[DASHBOARD_RESOURCES.athenaDashboard]: athenaDashboard,
	[DASHBOARD_RESOURCES.adsDashboard]: banner,
	[DASHBOARD_RESOURCES.chatDashboard]: social,
	[DASHBOARD_RESOURCES.aiCompanionDashboard]: aiCompanion,
	[DASHBOARD_RESOURCES.gameplayGuardrailReview]: aiCompanion,
	[DASHBOARD_RESOURCES.configImpact]: app,
	[DASHBOARD_RESOURCES.talkzyData]: social,
	[DASHBOARD_RESOURCES.mandateRefund]: downtimeRefund
};
